import { PopoutDataType, setPopoutData } from 'owa-popout-store';
import { getUserPermissionForFolderId } from 'owa-mail-filterable-menu-behavior';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { isFolderOfTreeType, SHARED_FOLDERS_TREE_TYPE, ARCHIVE_FOLDERS_TREE_TYPE, isPublicFolder, } from 'owa-folders';
import { trace } from 'owa-trace';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { getFolderIdFromTableView } from 'owa-mail-search';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { publicFolderFavoriteStore } from 'owa-public-folder-favorite';
/**
 * Utility to prepare popout data for reading pane scenario
 * @param tableView
 */
export default function preparePopoutDataForReadingPane(tableView) {
    var folderId = getFolderIdFromTableView(tableView);
    if (folderId) {
        if (isMailFeatureEnabled('tri-sharedFolders') &&
            isFolderOfTreeType(folderId, SHARED_FOLDERS_TREE_TYPE)) {
            setPopoutDataForSharedFolders(folderId);
        }
        else if (isControlFeatureEnabled('tri-archive-mailbox') &&
            isFolderOfTreeType(folderId, ARCHIVE_FOLDERS_TREE_TYPE)) {
            setPopoutDataForArchiveMailbox(folderId);
        }
        else if (isControlFeatureEnabled('pf-favorite') && isPublicFolder(folderId)) {
            setPopoutDataForPublicFolder(folderId);
        }
    }
}
/**
 * Utility to set the popout data with required folder data for shared folders
 * This is exported only for test purpose and need not be used directly. Use the wrapper preparePopoutDataForReadingPane instead
 * @param folderId
 */
export function setPopoutDataForSharedFolders(folderId) {
    try {
        var folderData = {
            folderId: folderId,
            treeType: SHARED_FOLDERS_TREE_TYPE,
            permission: getUserPermissionForFolderId(folderId, getUserConfiguration().SessionSettings.UserEmailAddress),
        };
        setPopoutData(PopoutDataType.ReadingPanePopoutItemFolderInfo, folderData);
    }
    catch (e) {
        trace.error('setPopoutDataForSharedFolders failed : ' + e);
    }
}
/**
 * Utility to set the popout data with required folder data for archive mailbox
 * This is exported only for test purpose and need not be used directly. Use the wrapper preparePopoutDataForReadingPane instead
 * @param folderId
 */
export function setPopoutDataForArchiveMailbox(folderId) {
    try {
        var folderData = {
            folderId: folderId,
            treeType: ARCHIVE_FOLDERS_TREE_TYPE,
        };
        setPopoutData(PopoutDataType.ReadingPanePopoutItemFolderInfo, folderData);
    }
    catch (e) {
        trace.error('setPopoutDataForArchiveMailbox failed : ' + e);
    }
}
export function setPopoutDataForPublicFolder(folderId) {
    try {
        var sourceFolder = publicFolderFavoriteStore.folderTable.get(folderId);
        var folderData = {
            folderId: folderId,
            treeType: 'favorites',
            replicaItem: sourceFolder.ReplicaList[0],
        };
        setPopoutData(PopoutDataType.ReadingPanePopoutItemFolderInfo, folderData);
    }
    catch (e) {
        trace.error('setPopoutDataForPublicFolder failed : ' + e);
    }
}
//# sourceMappingURL=preparePopoutDataForReadingPane.js.map